import React from 'react';
import { Link, Typography, makeStyles } from '@forgeglobal/design-framework';

import { defaultErrorStyle } from './style';
import { FORGETRUST } from '@tcs/common/assets/constants';

const useStyles = makeStyles(defaultErrorStyle);

export const DefaultError = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="h2" color="textPrimary">
        Uh oh!
      </Typography>
      <Typography
        variant="body1"
        color="textPrimary"
        className={classes.message}>
        Looks like something went wrong
        <br />
        {"But rest assured - our team has been notified and we're on it!"}
      </Typography>
      <Typography variant="body1" className={classes.supportMessage}>
        If this continues to be a problem, please reach out to us.
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            call:{' '}
            <Link href={`tel:${FORGETRUST.PHONE}`}>{FORGETRUST.PHONE}</Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            email:{' '}
            <Link href={`mailto:${FORGETRUST.EMAIL}`}>{FORGETRUST.EMAIL}</Link>
          </Typography>
        </li>
      </ul>
    </div>
  );
};
